import { apiRequest } from "@/services/api";
import styleProfile from "../../style-profile"
import utils from '@/store_utils'
import {default as store} from "@/store";
import { customLogger } from "@/utils";
import eventBus from "@/services/eventBus";

const state = {
  guid: null,
  id: null,
  style_profile_prev_key: null,
  style_profile_key: null,
  style_profile_resume: false,
  style_profile: false,
  dislike_mode: false,
  data: {},
  lang: "fr",
  gender: undefined,
  messages: [],
  to_save: {"to_save": {}},
  sub_category: undefined,
  sub_sub_category: undefined,
  selected_quiz: undefined,
  selected_brands: undefined,
  selected_filter: undefined,
  conversation_id : undefined,
  chat_typing_indicator: false,
  phone: undefined,
  questionCounter: 0,
  modal_reco_sizeModal: undefined,
  modal_reco_sizeContent: undefined,
  modal_reco_sizeError: false,
  modal_reco_sizeLang: undefined,
  attachBox: false,
  loading_indicator: false, // for streaming message and openai messages
  user_session: undefined,
  page_title : "Accueil",
  page_subtitle : "En cours de formation",
  streaming_message: null,
  blocking_modal_sent: {
    normal_bahaviour: false,
    finished_time_no_10points: false,
    points_done_no_time: false,
  },
};

const actions = {

  setPageTitle({ commit }, title) {
    commit('setPageTitle', title);
  },
  setPageSubtitle({ commit }, subtitle) {
    commit('setPageSubtitle', subtitle); 
  },


  FETCH_USER_DATA: async ({ state, commit }, style_profile_resume = false) => {
    try{
      const response = (await apiRequest().get("users/data")).data.data;
      let data = response.data
      const subscription = response?.subscription
      if (response?.user_session){
        state.user_session = response.user_session
        state.questionCounter = state.user_session?.number_posed_questions || 0
        customLogger("User Questions Counter is: ", state.questionCounter)
      }
      if (data && data.last_step) {
        commit("SET_STYLE_PROFILE_KEY", data.last_step)
        if (style_profile_resume)
          commit('STYLE_PROFILE_RESUME')
      }

      if (store.state.config.storeId != 46){
        commit("SET_DATA", { ...data, subscription });
      }
      commit("SET_USER_ID", response.guid);
      commit("SET_USERID", response.id);
      commit('SET_PHONE_NUMBER', response?.phone_number)
      return data;
    }catch(e){
      customLogger("FETCH_USER_DATA error", e)
      throw e
    }
  },

  FETCH_USER_MESSAGES: async ({ commit, rootState, state }) => {
    let messages = (await apiRequest().get("users/messages")).data.data;
    let At = new Date();
    messages.map((message) => {
      let m = message;
      try {
        if (typeof message.content !== "object") {
          m.content = JSON.parse(message.content);
        }
        if (typeof message.content === 'number' || typeof message.content === 'integer' ) {
          message.content = message.content.toString()
        }
        return m;
      } catch (e) {
        return m;
      }
    });
    if(rootState.config.storeId == 87){
      commit('SET_STYLE_PROFILE_KEY', "start")
      commit("SET_MESSAGES", messages);
      store.dispatch("CURRENT_STYLE_PROFILE_STEP");
      return messages;
    }
    if (rootState.config.storeId == 38) {
      commit('SET_STYLE_PROFILE_KEY', "start")
      commit("SET_MESSAGES", messages);
      return messages;
    }
    if (rootState.config.storeId == 59) {
      store.commit("SET_MODE", "style_profile");
      store.commit('SET_STYLE_PROFILE_KEY', store.state.user.style_profile_key || "start")
      commit("SET_MESSAGES", messages);
      store.dispatch("CURRENT_STYLE_PROFILE_STEP");

      // init page title 
      const step = store.state.config.steps[store.state.user.style_profile_key]
      if(step?.page_title?.title) {
        store.dispatch('setPageTitle', step.page_title.title);
      }
      if(step?.page_title?.subtitle) {
          store.dispatch('setPageSubtitle', step.page_title.subtitle);
      }

      return messages;
    }
    let popup = !!(rootState.config.details.popup)
    // customLogger(popup)
    let welcome_message = "chat.welcome_inact"
    if (store.state.config.chat_config.chat_state.state == "active") {
      welcome_message = "chat.welcome"
    }
    else if (store.state.config.chat_config.chat_state.state == "not_reactive") {
      welcome_message = "chat.welcome_notreact"
    }
    if (messages.length == 0) {
      messages = [
        {
          sender_type: "bot",
          content: {
            message: (popup !== false && rootState.config.details.popup.message)  ? rootState.config.details.popup.message : welcome_message,
            buttons: (popup !== false && rootState.config.details.popup.buttons) ? rootState.config.details.popup.buttons : [],
          },
          sent_at: At.toISOString()
        },
      ]
      if (messages[0].content.buttons.length === 0) {
        if (rootState.config.chat_enabled) {
          messages[0].content.buttons.push({name: "popup.proposition2", value: "first_suggestion"})
        }
        if (!(rootState.config.details.no_proposition1 === true)) {
          messages[0].content.buttons.push({name: "popup.proposition1", value: "go_search"})
        }
        if (Object.keys(rootState.config.steps).length && !(rootState.config.details.Iwantreco === false)) {
          messages[0].content.buttons.push({name: "popup.proposition4", value: "start"})
        }
        if (!(rootState.config.details.no_proposition3 === true))
        messages[0].content.buttons.push({name: "popup.proposition3", value: "first_suggestion"})
      }
    }
    if (rootState.config.storeId == 33) {
      commit('SET_STYLE_PROFILE_KEY', "start")
      messages[0].content.message = null
    }
    if (rootState.config.storeId == 50) {
      commit('SET_STYLE_PROFILE_KEY', "start")
    }
    if (rootState.config.storeId == 25) {
      commit('SET_STYLE_PROFILE_KEY', "start")
    }
    commit("SET_MESSAGES", messages);
    return messages;
  },

  CURRENT_STYLE_PROFILE_STEP: async ({ commit, state, rootState }) => {
    commit('ENABLE_STYLE_PROFILE');
    const At = new Date();
    if (state.messages.length > 0) {
      const last_msg = state.messages[state.messages.length - 1]

      if (last_msg.content.step == state.style_profile_key) return
    }

    var message = rootState.config.steps[state.style_profile_key].message

    if (Array.isArray(message)) {
      message = message[Math.floor(Math.random() * message.length)]
    }

    const step_type = rootState.config.steps[state.style_profile_key].step_type || null

    const send = {
      sender_type: "bot",
      content: {
        message: message,
        buttons: step_type ? rootState.config.steps[state.style_profile_key].buttons[state.data[step_type]] : rootState.config.steps[state.style_profile_key].buttons,
        selection: step_type ? rootState.config.steps[state.style_profile_key].selection[state.data[step_type]] : rootState.config.steps[state.style_profile_key].selection,
        questions: step_type ? rootState.config.steps[state.style_profile_key].questions[state.data[step_type]] : rootState.config.steps[state.style_profile_key].questions,
        carousel: rootState.config.steps[state.style_profile_key].carousel,
        grid: rootState.config.steps[state.style_profile_key].grid,
        brands: rootState.config.steps[state.style_profile_key].brands,
        form: rootState.config.steps[state.style_profile_key].form,
        look: rootState.config.steps[state.style_profile_key].look,
        multi: rootState.config.steps[state.style_profile_key].multi,
        step: state.style_profile_key
      },
      typing_indicator: false,
      sent_at: At.toISOString(),
    };

    commit("PUSH_MESSAGE", send);

    // fetch reco !
    utils.get_products(send.content)
  },

  FETCH_STYLE_PROFILE_STEP: async (
    { commit, dispatch, rootState, state }
  ) => {
    commit('ENABLE_STYLE_PROFILE');
    commit('SET_STYLE_PROFILE_PREV_KEY')
    const At = new Date();
    const keyStore = await styleProfile.NEXT_KEY_STYLE_PROFILE_STEP();

    customLogger('keyStore store', keyStore)

    if (keyStore == null) return;

    var message = rootState.config.steps[state.style_profile_key].message

    if (Array.isArray(message)) {
      message = message[Math.floor(Math.random() * message.length)]
    }

    const step_type = rootState.config.steps[keyStore].step_type || null

    const send = {
      sender_type: "bot",
      content: {
        message: message,
        buttons: step_type ? rootState.config.steps[keyStore].buttons[state.data[step_type]] : rootState.config.steps[keyStore].buttons,
        selection: step_type ? rootState.config.steps[keyStore].selection[state.data[step_type]] : rootState.config.steps[keyStore].selection,
        questions: step_type ? rootState.config.steps[keyStore].questions[state.data[step_type]] : rootState.config.steps[keyStore].questions,
        carousel: rootState.config.steps[keyStore].carousel ? Object.assign({}, rootState.config.steps[keyStore].carousel) : null,
        grid: rootState.config.steps[keyStore].grid ? Object.assign({}, rootState.config.steps[keyStore].grid) : null,
        brands: rootState.config.steps[keyStore].brands,
        form: rootState.config.steps[keyStore].form ? Object.assign({}, rootState.config.steps[keyStore].form) : null,
        look: rootState.config.steps[keyStore].look ? Object.assign({}, rootState.config.steps[keyStore].look) : null,
        multi: rootState.config.steps[keyStore].multi ? Object.assign({}, rootState.config.steps[keyStore].multi) : null,
        step: keyStore
      },
      typing_indicator: false,
      sent_at: At.toISOString(),
    };
    if(keyStore == "FILTERED_RECO")
      send.content.carousel.already_explored=false
    // before we need to save data
    await dispatch('SAVE_STYLE_PROFILE_STEP')

    commit("PUSH_MESSAGE", send);

    if (keyStore.includes("get_size")) {
      var size_reco
      size_reco = await dispatch('GET_SIZE_RECOMMENDATION')

      var noo_size_norm = ["norm.spe_bonnetD","norm.warning_170","norm.warning_inf","norm.warning_spe","norm.warning_top_spe","norm.warning_top_sup","norm.warnig_170_tall_between_2_sizes", "norm.norm_default_170_small", "norm.same_size_small_no_between"]

      if((store.state.config.storeId == 49) && (rootState.config.steps[keyStore].message.includes("message.get_size_") || noo_size_norm.includes(rootState.config.steps[keyStore].message))){
        utils.emit_message({
          message: size_reco.toString(),
          commit: true,
          dialogflow: false,
          slack: true,
          sender: 'bot'
        });
        utils.emit_message({
          message: {
            message: rootState.config.steps[keyStore].message.includes("message.get_size_") ? rootState.config.steps[keyStore].message.replace("message", "message_pt2") : rootState.config.steps[keyStore].message.replace("norm", "norm_pt2"),
            buttons: [{name: "nomore.restart", value: "restart"}],
            condition: {"restart": Object.keys(rootState.config.steps)[0]}
          },
          commit: true,
          dialogflow: false,
          slack: true,
          sender: 'bot'
        });
      } else {
        utils.emit_message({
          message:  {
              message: size_reco.toString(),
              buttons: [
                {name: "nomore.restart", value: "restart"}
              ],
              condition: {
                "restart": Object.keys(rootState.config.steps)[0]
              }
          },
          commit: true,
          dialogflow: false,
          sender: 'bot'
        })
      }
    }

    // fetch reco !
    await utils.get_products(send.content)

    if (send.content.carousel && send.content.carousel.mode === 'explore'
    || send.content.look && send.content.look.mode === 'explore') {
      // save step
      utils.emit_message({
        message: send.content,
        sender: 'bot',
      })
    }


    return message;
  },

  // PREPARE_SAVE_STYLE_PROFILE_STEP: async ({state, commit}, obj_user_answer = null) => {
  //   let to_save = {
  //     to_save: {
  //       last_step: (obj_user_answer != null && obj_user_answer.last_step) ? obj_user_answer.last_step : state.style_profile_key,
  //     }
  //   };
  //
  //   if (obj_user_answer != null) {
  //     delete  obj_user_answer.last_step
  //     to_save.to_save = { ...to_save.to_save, ...obj_user_answer }
  //   }
  //
  //   commit('SET_TO_SAVE', to_save)
  //
  //   delete state.data.tmp_content
  // },

  SAVE_STYLE_PROFILE_STEP: async ({ state, dispatch, commit }) => {

    // final = to_save
    state.to_save.to_save.last_step = state.style_profile_key
    await apiRequest().post("users/data", state.to_save)
      .then(_ => commit('UPDATE_DATA', state.to_save.to_save))
      .catch(async _ => await dispatch('FETCH_USER_DATA'))
  },

  GET_RECOMMENDATION: async ({ dispatch, state, commit }, opt) => {
    if (state.data.last_step != 'first_reco_noel' && state.data.last_step != 'second_reco_noel' && state.data.last_step != 'ENDLESS_RECO_NOEL' && state.data.last_step != 'third_reco_noel') {
      customLogger("gender_noel cleaned because: ", state.data.last_step);
      delete state.data.gender_noel
    }
    const contentMessage = state.messages[state.messages.length - 1].content
    customLogger("state.date = ", state.data)
    let to_send = state.data

    if (opt.filter) {
      let apply = {}
      if (state.data.FILTER.filter)
        apply[state.data.FILTER.filter] = state.data.FILTER.value
      else
        apply[state.data.get_filter_condition.filter] = state.data.FILTER.value

      to_send = {
        ...state.data,
        mode: "filter",
        filters: apply
      }
    }
    if (opt.filters) {
      to_send = {
        ...state.data,
        mode: "filter",
        ...opt
      }
    }
    customLogger("Popularity: ", opt.popularity)
    if (opt.popularity) {
      to_send = {
        ...state.data,
        popularity: true,
        ...opt
      }
    }

    customLogger("Product seen reco: ", opt.product_seen_reco)
    if (opt.product_seen_reco) {
      to_send['product_seen_reco'] = "true"
    }


    const res = await apiRequest()
      .post('grid/recommendation', {...to_send, lang: state.lang})

    if (res.data && res.data.products && res.data.products.length > 0) {
      // commit('SAVE_RECO', res.data.products)
      // save in obj message before we send it to api otherwise it'll be never saved
      if (contentMessage[opt.component_type])
        contentMessage[opt.component_type].already_explored = res.data.products
      return res.data.products
    } else
      return null;
  },

  GET_SIZE_RECOMMENDATION: async ({ rootState, dispatch, state, commit }, opt) => {
    const contentMessage = state.messages[state.messages.length - 1].content
    let to_send = state.data

    const res = await apiRequest()
      .post('grid/size-guide', {...to_send, store_id: rootState.config.storeId, lang: state.lang})

    // customLogger('res',res)
    // customLogger('data', state.data)
    delete state.data.wear_type
    delete state.data.hips_rather
    delete state.data.intimates
    delete state.data.swimwear
    delete state.data.clothes
    delete state.data.intimates_bras
    delete state.data.intimates_bodysuits
    delete state.data.intimates_bottoms
    delete state.data.intimates_bras_softbras
    delete state.data.intimates_bras_underwirebras
    delete state.data.intimates_softbras_triangle
    delete state.data.intimates_softbras_balcony
    delete state.data.intimates_underwirebras_longline
    delete state.data.intimates_underwirebras_demi
    delete state.data.intimates_underwirebras_balcony
    delete state.data.intimates_bodysuits_body_demi
    delete state.data.intimates_bodysuits_triangle_bodysuit
    delete state.data.intimates_bottoms_tanga
    delete state.data.intimates_bottoms_hw
    delete state.data.intimates_bottoms_thong
    delete state.data.intimates_bottoms_short
    delete state.data.swimwear_onepiece
    delete state.data.swimwear_twopiece
    delete state.data.swimwear_twopiece_for_you_bikini
    delete state.data.swimwear_twopiece_malibu
    delete state.data.swimwear_twopiece_palm_springs
    delete state.data.swimwear_twopiece_resort
    delete state.data.swimwear_twopiece_so_chic
    delete state.data.swimwear_twopiece_good_vibes_collection
    delete state.data.clothes_triangle
    delete state.data.clothes_thong
    delete state.data.clothes_bandeau
    delete state.data.clothes_tanga
    delete state.data.clothes_shirt
    delete state.data.clothes_crop_shirt
    delete state.data.clothes_bra
    delete state.data.clothes_slip_dress
    delete state.data.clothes_rib_cotton_clothes
    delete state.data.Top_measurements
    delete state.data.Bottom_measurements
    delete state.data.Body_measurements
    delete state.data.Body_Dress_size


    delete state.data.collection
    delete state.data.norm_special
    delete state.data.norm_special_eu
    delete state.data.norm_special_fr
    delete state.data.norm_top_bras
    delete state.data.norm_top_bras_eu
    delete state.data.norm_top_bras_fr
    delete state.data.norm_bot_culotte
    delete state.data.norm_bot_culotte_eu
    delete state.data.norm_chemise
    delete state.data.norm_combi_spe
    delete state.data.norm_combi_spe_fr
    delete state.data.norm_combi_spe_eu
    delete state.data.norm_default
    delete state.data.norm_default_spe
    delete state.data.norm_pantalon
    delete state.data.norm_combi_spe
    delete state.data.norm_top_bras_spe
    delete state.data.norm_top_default
    delete state.data.norm_bot_default
    delete state.data.norm_robe
    delete state.data.norm_robe_sup
    delete state.data.norm_top_spe
    delete state.data.norm_tee_shirt
    delete state.data.norm_bot_culotte_spe
    delete state.data.norm_kimono
    delete state.data.norm_kimono_eu
    delete state.data.norm_kimono_fr
    delete state.data.norm_kimono_bis
    delete state.data.norm_kimono_eu_bis
    delete state.data.norm_kimono_fr_bis
    delete state.data.norm_sup_size_spe_short
    delete state.data.norm_sup_size_spe_short_eu
    delete state.data.norm_sup_size_spe_short_fr
    delete state.data.norm_sup_size_spe_pantalon
    delete state.data.norm_sup_size_spe_pantalon_eu
    delete state.data.norm_sup_size_spe_pantalon_fr
    delete state.data.norm_inf_size_spe_short
    delete state.data.norm_inf_size_spe_short_eu
    delete state.data.norm_inf_size_spe_short_fr
    delete state.data.norm_inf_size_spe_pantalon
    delete state.data.norm_inf_size_spe_pantalon_eu
    delete state.data.norm_inf_size_spe_pantalon_fr
    delete state.data.norm_pantalon_eu
    delete state.data.norm_chemise_eu
    delete state.data.norm_special_brassiere
    delete state.data.tees_tops
    delete state.data.tees_tops_tops
    delete state.data.norm_special_brassiere_fr
    delete state.data.norm_special_brassiere_eu
    delete state.data.norm_tee_shirt_sup_eu
    delete state.data.norm_robe_eu
    delete state.data.norm_default_eu
    delete state.data.categorie
    delete state.data.norm_special
    delete state.data.norm_special_brassiere2
    delete state.data.norm_special_brassiere2_fr
    delete state.data.norm_special_brassiere2_eu
    delete state.data.norm_bras_haut_fr
    delete state.data.norm_bras_haut_eu
    delete state.data.norm_default_170_eu
    delete state.data.norm_default_sup
    delete state.data.norm_default_sup_eu
    delete state.data.norm_default_sup_fr
    delete state.data.body_guide_SG_fr
    delete state.data.body_guide_SG_eu
    delete state.data.body_guide_size
    delete state.data.body_guide_culotte_fr
    delete state.data.body_guide_culotte_eu
    delete state.data.norm_multi_shape
    delete state.data.norm_multi_shape_fr
    delete state.data.norm_multi_shape_eu
    delete state.data.bodys_manches_longues
    delete state.data.norm_spe_ajuste_eu
    delete state.data.norm_special_brassiere_sup
    delete state.data.norm_special_brassiere_sup_fr
    delete state.data.norm_special_brassiere_sup_eu
    delete state.data.norm_between_2_sizes_eu
    delete state.data.norm_top_golden_navy
    delete state.data.norm_top_golden_navy_fr
    delete state.data.norm_top_golden_navy_eu
    delete state.data.norm_special_bandeau_swim_hot_tiger
    delete state.data.norm_special_bandeau_swim_hot_tiger_fr
    delete state.data.norm_special_bandeau_swim_hot_tiger_eu
    delete state.data.norm_top_bras_armature
    delete state.data.norm_top_bras_armature_fr
    delete state.data.norm_top_bras_armature_eu
    delete state.data.norm_default_170_tall
    delete state.data.norm_default_170_tall_eu
    delete state.data.norm_default_170_tall_fr
    delete state.data.norm_default_170_between_2_size
    delete state.data.norm_default_170_between_2_size_eu
    delete state.data.norm_default_170_between_2_size_fr

    if (res.data && res.data.size) {
      return res.data.size
    } else
      return null;
  },


  GET_LOOK: async ({ state, commit }) => {
    const contentMessage = state.messages[state.messages.length - 1].content
    const res = await apiRequest()
      .post('products/look', {
        style: (state.data && state.data.style) ? state.data.style.split('.')[1] : '',
        gender: state.gender ? state.gender : state.data.gender
      })

    if (res.data && res.data.response) {
      // commit('SAVE_LOOK', res.data.response)

      let ret = res.data.response
      const look = await apiRequest()
            .get("products/list/" + res.data.response.product_ids.join(","))

      if (look && look.data && look.data.products)
        ret.down = look.data.products

      if (contentMessage.look)
        contentMessage.look.already_explored = true

      return ret
    } else {
      return null
    }
  },

  GET_COMMAND: async(context, payload) => {
    return apiRequest().get('command', {params: payload})
  },
  CREATE_TICKET: async(context, payload) => {
    return apiRequest().post('zendesk', {params: payload})
  },

  SAVE_EMAIL: async (context, email) => {
    apiRequest().post('users/email', { email })
  },

  SEND_EMAIL_BRAND: async (context, payload) => {
    try {
      if (store.state.config.emailActivate) {
        await apiRequest().post('message/EmailSendBrand', {params: payload})
      } else { 
        throw new Error('Email is not activate')
      }
    } catch(err) {
      throw err
    }
  },

  PRODUCT_SEEN: async (context, product_ids) => {
    apiRequest().post('users/seen', { product_ids: product_ids })
  },
  GIVE_FEEDBACK: ({ commit, dispatch }, rate) =>
      new Promise((resolve, reject) => {
        apiRequest()
          .put( `rating/feedback/${rate}`)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      }),

  /*
  FETCH_PRODUCTS_ADDED_TO_CART: async ({state,commit}) => {
    response = await apiRequest().get("my/productAddedToCart")

    products_added_to_cart = response.data.result[0].all_products_added_to_car.split(',')

    dates_products_added_to_cart = response.data.result[0].product_date.split(',')

    commit('SET_DATA', {
      "products_added_to_cart":products_added_to_cart,
      "dates_products_added_to_cart": dates_products_added_to_cart
    })
  }
  */

  CHECK_PHONE_NUMBER: ({ commit, dispatch }, { cc, phone }) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .get(`whatsapp/check/${phone}/${cc}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),

  SAVE_PHONE_NUMBER: ({ commit, dispatch }, { dc, phone }) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .put( "whatsapp/register", { dialing_code: dc, phone_number: phone })
        .then(({ data }) => {
          commit('SET_PHONE_NUMBER', data?.user?.phone_number)
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  SUBMIT_MESSAGE_CHECKER: async ({ commit }, { id, note }) => {
    commit('SET_OPENAI', note)
  },

  FETCH_MODELS: async () => {
    return (await apiRequest().get("virtual/models")).data;
  },
  FETCH_GARMENTS: async () => {
    return (await apiRequest().get("virtual/garments")).data;
  },
  // FETCH_LOOK: async ({}, { model, top, bottom }) => {
  //   customLogger(model, top, bottom)
  //   return (await apiRequest().get('virtual/look', { model, top, bottom })).data;
  // },


  FETCH_LOOK: ({ commit, dispatch }, { model, top, bottom }) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .post( "virtual/look", { model: model, top: top, bottom: bottom })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),

  FETCH_SIZE_RECO: async ({ rootState }, { dataLayerContent }) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .post( "size_reco/"+rootState.config.storeId+"/get_sizes", { storeId: parseInt(rootState.config.storeId), dataLayerContent: dataLayerContent })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e.response.data.message);
        }
      );
    }),

  FETCH_BRANDS: async ({ rootState }, { dataLayerContent }) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .post( "size_reco/"+rootState.config.storeId+"/get_logos", { storeId: parseInt(rootState.config.storeId), dataLayerContent: dataLayerContent })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e.response.data.message);
        }
      );
    }),

    FETCH_SIZES: async ({ rootState }, { dataLayerContent, size_type, input_size_type, foot_size, input_brand }) =>
      new Promise((resolve, reject) => {
        apiRequest()
          .post( "size_reco/"+rootState.config.storeId+"/size_guide", { storeId: parseInt(rootState.config.storeId), dataLayerContent: dataLayerContent, size_type: size_type, input_size_type: input_size_type, foot_size: foot_size, input_brand: input_brand })
          .then(({ data }) => {
            resolve(data);
            return data.data;
          })
          .catch((e) => {
            reject(e);
            return e.response.status;
          }
        );
      }),

      FETCH_DETAILS: async ({ rootState }, { dataLayerContent }) =>
        new Promise((resolve, reject) => {
          apiRequest()
            .post( "size_reco/"+rootState.config.storeId+"/descriptionize_reco", { 
                storeId: parseInt(rootState.config.storeId),
                dataLayerContent: dataLayerContent 
              })
            .then(({ data }) => {
              resolve(data.data);
            })
            .catch((e) => {
              reject(e);
            }
          );
      }),

    FETCH_MANFIELD_VERIFY_PRODUCT: async ({ rootState }, { dataLayerContent }) =>
      new Promise((resolve, reject) => {
        apiRequest()
          .post( "size_reco/20/verify_product", { storeId: parseInt(rootState.config.storeId), dataLayerContent: dataLayerContent })
          .then(({ data }) => {
            resolve(data);
            return data.data;
          })
          .catch((e) => {
            reject(e);
            return e.response.status;
          }
        );
      }),

    FETCH_LEX_VERIFY_PRODUCT: async ({ rootState }, { dataLayerContent }) =>
        new Promise((resolve, reject) => {
          apiRequest()
            .post( "size_reco/33/verify_product", { storeId: parseInt(rootState.config.storeId), dataLayerContent: dataLayerContent })
            .then(({ data }) => {
              resolve(data);
              return data.data;
            })
            .catch((e) => {
              reject(e);
              return e.response.status;
            }
          );
      }),

    FETCH_SIZES_NOO: async ({ rootState }, { url, size_type }) =>
      new Promise((resolve, reject) => {
        apiRequest()
          .post( "size_reco/46/get_sizes", { storeId: parseInt(rootState.config.storeId), url: url, size_type: size_type })
          .then(({ data }) => {
            resolve(data);
            return data.data;
          })
          .catch((e) => {
            reject(e);
            return e.response.status;
          }
        );
      }),

      FETCH_NOO_VERIFY_PRODUCT: async ({ rootState }, { url }) =>
      new Promise((resolve, reject) => {
        apiRequest()
          .post( "size_reco/46/verify_product", { storeId: parseInt(rootState.config.storeId), url: url })
          .then(({ data }) => {
            resolve(data);
            return data.data;
          })
          .catch((e) => {
            reject(e);
            return e.response.status;
          }
        );
      }),

    FETCH_NOO_SIZE_GUIDE: async ({ rootState }, { data }) =>
      new Promise((resolve, reject) => {
        data = {...data, storeId: parseInt(rootState.config.storeId)}
        apiRequest()
          .post( "size_reco/46/size_guide", data)
          .then(({ data }) => {
            resolve(data);
            return data.data;
          })
          .catch((e) => {
            reject(e);
            return e.response.status;
          }
        );
      }),

    SET_ATTACH_BOX: ({ commit }, attachBox) => {
      attachBox.showing = true;
      commit("SET_ATTACHBOX", attachBox);
    },

    SEND_ATTACHMENTS: async ({}, { formData, guid }) => {
      return apiRequest()
        .post(`attachments/box/${guid}`, formData)
        .then(({ data }) => {
          return data;
        })
        .catch((e) => {
          throw e;
        })
    },
    HANDLE_PAYMENT: async ({ rootState, commit }, params) => {
      return apiRequest()
        .post(`payments/create_payment_intent/${rootState.config.storeId}`, {...params, lang: rootState.user.lang})
        .then(({ data }) => {
          return data?.newSubscription?.subscription;
        })
        .catch((e) => {
          throw e;
        })
    },
    REFRESH_USER: async ({ rootState, commit }, params) => {
      return apiRequest()
        .post(`payments/refresh_user`)
        .then(({ data }) => {
          return data;
        })
        .catch((e) => {
          throw e;
        })
    },
    PAYMENT_EXPIRED: async () => {
      return apiRequest()
        .post(`payments/payment_expired`)
        .then(({ data }) => {
          return data;
        })
        .catch((e) => {
          throw e;
        })
    },
    RATING_FEEDBACK: async ({ commit }, { feedback, feedback_categorie }) => {
      return apiRequest()
        .post(`users/rating_feedback`, { feedback, feedback_categorie })
        .then(({ data }) => {
          return data;
        })
        .catch((e) => {
          throw e;
        })
    },
    UPDATE_STREAMING_MESSAGE: ({commit, state}, data) => {
      // customLogger("UPDATE_STREAMING_MESSAGE", data);
      if (data.chunk && !data.end) {
        state.streaming_message = data.chunk;
      }else{
        state.loading_indicator = data.keepLoader ? true : false
        if (data.push_message) {
          const At = new Date();
          commit("PUSH_MESSAGE", {
            sender_type: "bot",
            content: {
              message: state.streaming_message,
              id: data?.id,
              ai_generated: data?.ai_generated || false,
              feedbackCategorie: data?.feedbackCategorie,
            },
            typing_indicator: false,
            sent_at: At.toISOString(),
          });
        }
        state.streaming_message = null
      }
    },
    UPDATE_DIFFICULTY: async ({ commit }, params) => {
      try {
        const res = await apiRequest().post('users/update_qcm_difficulty', params)
        commit("SET_DATA", { intro_exit_results: res.data.intro_exit_results })
        return res
      } catch (e) {  
        throw e
      }
    },
    UPDATE_FINISH_CONDITIONS: async ({ commit }) => {
      try {
        await apiRequest().post('users/update_finish_conditions')
      } catch (e) {
        throw e
      }
    },
    UPDATE_TIME_SPENT: async ({ commit, state, rootState }) => {
      try {
        const expected_work_hours = state?.data?.subscription?.expected_work_hours;
        const total_time_spent = state?.user_session?.total_time_spent;
        if (total_time_spent >= expected_work_hours) { // user reached time limit
          const qcmResultsKeys = state?.data?.qcm_results ? Object.keys(state.data.qcm_results) : [];
          if (qcmResultsKeys.length >= 10 && !state.blocking_modal_sent.normal_bahaviour) { // user finished all 10 points and time limit
            await store.dispatch("SET_MODAL", {
              body: "Vous avez fini votre formation, vous allez maintenant passer au QCM final.",
              type: "warning",
            }).then(async () => {
              state.questionCounter = 10;
              commit("SET_BLOCKING_MODAL", {
                ...state.blocking_modal_sent, 
                normal_bahaviour: true,
                finished_time_no_10points: true
              })
              const user_data = Object.keys(state.data);
              // customLogger("user_data", user_data);
              if (!user_data.includes("before_ending")) {
                styleProfile.generateNextStyleProfileStep("before_ending")
              }
            });
            
          } else { // user didn't finish all 10 points 
            if(!state.blocking_modal_sent.finished_time_no_10points){
              await store.dispatch("SET_MODAL", {
                body: "Vous avez atteint la fin du temps imparti pour cette formation, veuillez finir les 10 points clés pour pouvoir faire le QCM final.",
                type: "warning",
              }).then(async () => {
                state.questionCounter = 10;
                commit("SET_BLOCKING_MODAL", {
                  ...state.blocking_modal_sent, 
                  finished_time_no_10points: true
                })
                const user_data = Object.keys(state.data);
                // customLogger("user_data", user_data);
                if (!user_data.includes("start_quizz")) {
                  styleProfile.generateNextStyleProfileStep("start_quizz")
                }
              });
            }
          }
        } else { // user finished all 10 points but still have time
          const qcmResultsKeys = state?.data?.qcm_results ? Object.keys(state.data.qcm_results) : [];
          if (((qcmResultsKeys.length >= 10 && state.questionCounter >= 10)) && !state.blocking_modal_sent.points_done_no_time) {
            commit("SET_BLOCKING_MODAL", {
              ...state.blocking_modal_sent, points_done_no_time: true
            })
            state.questionCounter = 10;
            await store.dispatch("SET_MODAL", {
              body: `Vous avez fini le contenu de la formation, mais il vous reste du temps pour continuer à vous entrainer avant de passer au QCM final. Temps necessaire pour finir la formation: ${expected_work_hours/3600000} heures`,
              type: "warning",
            }).then(async () => {
              styleProfile.generateNextStyleProfileStep("start_quizz")
            });
          }
        }
    } catch (e) {
      customLogger(e);
    }
  },
  CANCEL_USER_SUBSCRIPTION: async ({ commit }) => {
    try {
      await dispatch("SET_MODAL", {
        body: "Vous avez atteint la fin de votre abonnement, veuillez vous réabonner pour continuer la formation.",
        type: "warning",
      }).then(async () => {
        await apiRequest()
          .post("users/subscriptions/stop", {
            userId: store.state.user.id,
          })
          .then(({ data }) => {
            store.dispatch("FETCH_USER_DATA");
            store
              .dispatch("SET_MODAL", {
                active: true,
                title: "Abonnement désactivé",
                body: "Votre abonnement a été désactivé ",
                type: "info",
              })
              .then(() => {
                store.commit("SHOW_SUBS_FLOW", true);
              });
            return data;
          })
          .catch((e) => {
            throw e;
          });
      });
    } catch (e) {
      throw e;
    }
  },

  STOP_SUBSCRIPTION: async ({ commit, dispatch }, { message }) => {
    try {
      await dispatch("SET_MODAL", {
        title: "Abonnement désactivé",
        type: "info",
        active: true,
        body: message,
      }).then((confirm) => {
        if (confirm) {
          return apiRequest()
            .post("users/subscriptions/stop", {
              userId: store.state.user.id,
            })
            .then(({ data }) => {
              store.dispatch("FETCH_USER_DATA");

              store
                .dispatch("SET_MODAL", {
                  active: true,
                  title: "Abonnement désactivé",
                  body: "Votre abonnement a été désactivé ",
                  type: "success",
                })
                .then(async () => {
                  store.commit("SHOW_SUBS_FLOW", true);
                });
              return data;
            })
            .catch((e) => {
              throw e;
            });
        }
      });
    } catch (e) {
      throw e;
    }
  },
};

const mutations = {
  // PAGE TITLE
  setPageTitle(state, title) {
    state.page_title = title;
  },
  setPageSubtitle(state, subtitle) {
    state.page_subtitle = subtitle; 
  },
  // END PAGE TITLE
  SET_DATA_SUBSCRIPTION(state, data) {
    state.data.subscription = data;
  },
  SET_PROFILE_STATE(state, data){
    state.data.profileState = data
  },
  SET_BLOCKING_MODAL(state, data){
    state.blocking_modal_sent = data
  },
  SET_DATA: (state, data) => {
    if (Object.keys(state.data).length > 0)
      state.data = { ...state.data, ...data }
    else
      state.data = data;
  },
  SET_USER_ID: (state, guid) => {
      state.guid = guid;
  },
  SET_USERID: (state, id) => {
    state.id = id;
  },
  UPDATE_DATA: (state, newData) => {
    state.data = { ...state.data, ...newData };
  },
  SET_LANG: (state, lang) => {
    state.lang = lang;
  },
  SET_MESSAGES: (state, messages) => {
    if (messages.length && messages[0].conversation_id) {
      state.conversation_id = messages[0].conversation_id
    }
    state.messages = messages;
  },
  PUSH_MESSAGE: (state, message) => {
    customLogger("je push bien dans message")
    customLogger(message)
    state.messages.push(message);
    customLogger(state.messages)
  },
  Message_TypingTracker: (state, data) => {
    customLogger(data);
    state.chat_typing_indicator = data.state == "focus" ? true : false
  },
  Message_live_change: (state, data) => {
    const index = state.messages.findIndex(
      (x) => x.id === data.id
    );
    if (index >= 0){
      if (data.action === 'edit')
            state.messages[index].content = data.data.content
      else if (data.action === 'delete')
          state.messages.splice(index, 1);
    }
},
 


  SET_STYLE_PROFILE_KEY: (state, key) => {
    state.style_profile_key = key;
  },
  DISABLE_STYLE_PROFILE: (state) => {
    state.style_profile = false;
  },
  ENABLE_STYLE_PROFILE: (state) => {
    state.style_profile = true;
  },
  STYLE_PROFILE_RESUME: (state) => {
    state.style_profile_resume = !state.style_profile_resume
  },
  SET_STYLE_PROFILE_PREV_KEY: (state) => {
    state.style_profile_prev_key = state.style_profile_key
  },
  // SAVE_RECO: (state, products) => {
  //   state.messages[state.messages.length - 1].content.grid.already_explored = products
  // },
  SET_TO_SAVE: (state, to_save) => {
    state.to_save = to_save
  },
  DELETE_TMP_CONTENT: (state) => {
    delete state.data.tmp_content
  },
  // SAVE_LOOK: (state, look) => {
  //   state.messages[state.messages.length - 1].content.look.already_explored = look
  // },
  DISLIKE_MODE: (state, value) => {
    state.dislike_mode = value
  },
  REMOVE_MSG_FROM_TS: (state, ts) => {
    state.messages = state.messages.filter(message => !(message.content.ts == ts))
  },
  SET_GENDER: (state, gender) => {
    state.data['gender'] = gender
  },
  SET_FILTERS: (state, filters) => {
    state.data['filters'] = filters
  },
  SET_SUB_CATEGORY: (state, sub_category) => {
    state.data['sub_category'] = sub_category
  },
  SET_SUB_SUB_CATEGORY: (state, sub_sub_category) => {
    state.data['sub_sub_category'] = sub_sub_category
  },
  SET_SELECTED_QUIZ: (state, quiz_name) => {
    state.data['selected_quiz'] = quiz_name
  },
  SET_SELECTED_BRANDS: (state, brands_name) => {
    state.data['selected_brands'] = brands_name
  },
  SET_SELECTED_FILTER: (state, filter_name) => {
    state.data['selected_filter'] = filter_name
  },
  RESET_QUIZ_OPTION: (state) => {
    // customLogger("STATE == ", state.data)
    delete state.data.gender_noel
    delete state.data.wear_type
    delete state.data.hips_rather
    delete state.data.intimates
    delete state.data.swimwear
    delete state.data.clothes
    delete state.data.intimates_bras
    delete state.data.intimates_bodysuits
    delete state.data.intimates_bottoms
    delete state.data.intimates_bras_softbras
    delete state.data.intimates_bras_underwirebras
    delete state.data.intimates_softbras_triangle
    delete state.data.intimates_softbras_balcony
    delete state.data.intimates_underwirebras_longline
    delete state.data.intimates_underwirebras_demi
    delete state.data.intimates_underwirebras_balcony
    delete state.data.intimates_bodysuits_body_demi
    delete state.data.intimates_bodysuits_triangle_bodysuit
    delete state.data.intimates_bottoms_tanga
    delete state.data.intimates_bottoms_hw
    delete state.data.intimates_bottoms_thong
    delete state.data.intimates_bottoms_short
    delete state.data.swimwear_onepiece
    delete state.data.swimwear_twopiece
    delete state.data.swimwear_twopiece_for_you_bikini
    delete state.data.swimwear_twopiece_malibu
    delete state.data.swimwear_twopiece_palm_springs
    delete state.data.swimwear_twopiece_resort
    delete state.data.swimwear_twopiece_so_chic
    delete state.data.swimwear_twopiece_good_vibes_collection
    delete state.data.clothes_triangle
    delete state.data.clothes_thong
    delete state.data.clothes_bandeau
    delete state.data.clothes_tanga
    delete state.data.clothes_shirt
    delete state.data.clothes_crop_shirt
    delete state.data.clothes_bra
    delete state.data.clothes_slip_dress
    delete state.data.clothes_rib_cotton_clothes
    delete state.data.Top_measurements
    delete state.data.Bottom_measurements
    delete state.data.Body_measurements
    delete state.data.Body_Dress_size
    // customLogger("STATE == ", state.data)
    var keys = Object.keys(state.data)
    for(var i = 0; i < keys.length; i++) {
      if (typeof state.data[keys[i]] == "string" && (state.data[keys[i]].includes('sub-category') || keys[i].includes('sub-category'))) {
        delete state.data[keys[i]]
      }
      if (typeof state.data[keys[i]] == "string" && keys[i].includes('product-type')) {
        delete state.data[keys[i]]
      }
      if (typeof state.data[keys[i]] == "string" && keys[i].includes('male')) {
        delete state.data[keys[i]]
      }
      if (typeof state.data[keys[i]] == "string" && keys[i].includes('female')) {
        delete state.data[keys[i]]
      }

      const mfk_quiz = [
        "bath_body_gift_type",
        "condition",
        "gift_selection",
        "gift_type_selection",
        "last_step",
        "opt_for",
        "recipient_selection",
        "scent_intensity_selection",
        "scent_selection",
      ]
      if (typeof state.data[keys[i]] == "string" && mfk_quiz.includes(keys[i])) {
        delete state.data[keys[i]]
      }

    }
    state.data.sub_sub_category = undefined
    state.data['selected_quiz'] = undefined
    state.data['selected_brands'] = undefined
  },
  RESET_SELECTED_FILTER: (state) => {
    state.data['selected_filter'] = undefined
  },
  RESET_SIZE_ADVICE: (state) => {
    delete state.data.user
  },
  SET_PHONE_NUMBER: (state, value) => {
    customLogger('SET_PHONE_NUMBER',value);
    state.phone = value;
  },
  SET_OPENAI: (state, value) => {
    state.openai = value;
  },
  SET_ATTACHBOX(state, attachBox) {
    state.attachBox = attachBox;
  },
};

const getters = {
  getPageTitle(state) {
    return { title: state.page_title, subtitle: state.page_subtitle };
  },
  getMessages(state) {
    return state.messages;
  }
};

export default {
  state,
  actions,
  mutations,
  getters,
};
